module.exports = __webpack_public_path__ + "media/images/brand/app_logo_full_topbar_mobile-64cde788b9a6b08458b0d6c8fb48398e.png";